import { NodeSelection } from 'prosemirror-state';
import React from 'react';
import { Decoration_Type } from 'ricos-schema';
import colorDataDefaults from 'ricos-schema/dist/statics/color.defaults.json';
import BlockSpoilerComponent from '../Components/BlockSpoilerComponent.js';
import 'prop-types';
import 'wix-rich-content-common';
import '../Components/SpoilerContainer.js';
import 'classnames';
import '../Components/SpoilerDescriptionInput.js';
import '../Components/EditableInputWrapper.js';
import '../Components/RevealButton.js';
import '../icons/SpoilerContainerIcon.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../spoiler-a30ad47f.js';
import 'lodash';
import '../types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SPOILER_STYLE = "blur(0.25em)";
const SpoilerHoc = (Component) => {
  const Spoiler = (props) => {
    var _a, _b;
    const { context, updateAttributes, node, editor, getPos, selected } = props;
    const { isMobile, theme, t } = context;
    if ((_b = (_a = node.attrs.containerData) == null ? void 0 : _a.spoiler) == null ? void 0 : _b.enabled) {
      const { spoiler } = node.attrs.containerData;
      const componentData = {
        config: {
          spoiler: __spreadProps(__spreadValues({}, spoiler), {
            buttonContent: spoiler.buttonText
          })
        }
      };
      const updateComponentData = (data) => {
        const containerData = __spreadProps(__spreadValues({}, node.attrs.containerData), { spoiler: __spreadValues(__spreadValues({}, spoiler), data) });
        updateAttributes({ containerData });
      };
      const handleDescriptionChange = (description) => updateComponentData({ description });
      const handleButtonContentChange = (buttonText) => updateComponentData({ buttonText });
      const setFocusToBlock = () => {
        if (!selected) {
          const selection = NodeSelection.create(editor.view.state.doc, getPos());
          const transaction = editor.view.state.tr.setSelection(selection);
          editor.view.dispatch(transaction);
        }
      };
      const pluginType = node.type.name[0] + node.type.name.toLowerCase().slice(1);
      return /* @__PURE__ */ React.createElement(
        BlockSpoilerComponent,
        {
          componentData,
          theme,
          isMobile,
          isEditableText: true,
          t,
          pluginType,
          handleDescriptionChange,
          handleButtonContentChange,
          setFocusToBlock,
          setInPluginEditingMode: () => {
          },
          disabledRevealSpoilerBtn: true
        },
        /* @__PURE__ */ React.createElement(Component, __spreadValues({}, props))
      );
    } else {
      return /* @__PURE__ */ React.createElement(Component, __spreadValues({}, props));
    }
  };
  Spoiler.displayName = "SpoilerHoc";
  return Spoiler;
};
const tiptapExtensions = [
  {
    type: "extension",
    name: "node-spoiler",
    groups: [],
    reconfigure: (config, extensions, _props, settings) => __spreadProps(__spreadValues({}, config), {
      addOptions: () => settings,
      addNodeHoc: () => ({
        nodeTypes: extensions.filter((extension) => extension.groups.includes("spoilerable")).map(({ name }) => name),
        priority: 10,
        nodeHoc: SpoilerHoc
      })
    }),
    createExtensionConfig() {
      return {
        name: this.name,
        priority: 10
      };
    }
  },
  {
    type: "mark",
    groups: [],
    name: Decoration_Type.SPOILER,
    createExtensionConfig({ isMarkActive }) {
      return {
        name: this.name,
        addOptions: () => ({
          HTMLAttributes: {}
        }),
        addAttributes() {
          return colorDataDefaults;
        },
        parseHTML() {
          return [
            {
              tag: "span",
              getAttrs: (element) => {
                const { filter } = element.style || {};
                return filter === SPOILER_STYLE ? {} : false;
              }
            }
          ];
        },
        renderHTML() {
          return ["span", { style: `filter: ${SPOILER_STYLE}` }, 0];
        },
        addCommands() {
          return {
            toggleSpoiler: () => ({ commands }) => {
              return commands.toggleMark(this.name);
            }
          };
        }
      };
    }
  }
];

export { tiptapExtensions };
//# sourceMappingURL=tiptap.js.map
